export default __webpack_public_path__ + "static/media/Hands_White.c4d5fbf7.png";